import React, { useEffect, useState } from 'react';
import { FaFacebook, FaTwitter, FaInstagram, FaTiktok, FaYoutube } from 'react-icons/fa';
import { getMayorSettings } from '../../api/mayorSettings';
import QuickMenu from '../../components/QuickMenu/QuickMenu';

function Mayor() {
  const [mayorData, setMayorData] = useState(null);
  const [loading, setLoading] = useState(true);

  const renderBiographyContent = () => {
    const description = mayorData?.mayorPageDescription?.trim();

    if (!description) {
      return <p>Başkan özgeçmiş bilgisi henüz eklenmemiştir.</p>;
    }

    if (description.includes('<') && description.includes('>')) {
      return <div dangerouslySetInnerHTML={{ __html: description }} />;
    }

    return description
      .split(/\r?\n\r?\n/)
      .filter((paragraph) => paragraph.trim())
      .map((paragraph, index) => <p key={index}>{paragraph.trim()}</p>);
  };

  useEffect(() => {
    const fetchMayorData = async () => {
      try {
        const response = await getMayorSettings();

        if (response.isSuccess && response.data) {
          setMayorData(response.data);
        }
      } catch (error) {
        console.error('Error fetching mayor data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchMayorData();
  }, []);

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  return (
    <div className="mayor-page">
      <div className="container py-5">
        <div className="row">
          <QuickMenu />

          <div className="col-md-10">
            <div className="mayor-content">
              <div className="mayor-image">
                <img src="/assets/images/mayor.jpg" alt="Belediye Başkanı" className="img-fluid" />
                <div className="mayor-social">
                  {mayorData?.facebookUrl && mayorData.facebookUrl.trim() !== ' ' && (
                    <a href={mayorData.facebookUrl} className="social-link" target="_blank" rel="noopener noreferrer">
                      <FaFacebook size={24} />
                    </a>
                  )}
                  {mayorData?.twitterUrl && mayorData.twitterUrl.trim() !== ' ' && (
                    <a href={mayorData.twitterUrl} className="social-link" target="_blank" rel="noopener noreferrer">
                      <FaTwitter size={24} />
                    </a>
                  )}
                  {mayorData?.instagramUrl && mayorData.instagramUrl.trim() !== ' ' && (
                    <a href={mayorData.instagramUrl} className="social-link" target="_blank" rel="noopener noreferrer">
                      <FaInstagram size={24} />
                    </a>
                  )}
                  <a href="https://www.tiktok.com/@mehmetdonmezbb" className="social-link" target="_blank" rel="noopener noreferrer">
                    <FaTiktok size={24} />
                  </a>
                  {mayorData?.youtubeUrl && mayorData.youtubeUrl.trim() !== ' ' && (
                    <a href={mayorData.youtubeUrl} className="social-link" target="_blank" rel="noopener noreferrer">
                      <FaYoutube size={24} />
                    </a>
                  )}
                </div>
              </div>

              <div className="mayor-bio">
                <h1 className="page-title">Başkan Özgeçmiş</h1>
                <h2 className="mayor-name">{mayorData?.nameSurname}</h2>
                <h3 className="mayor-title">İskenderun Belediye Başkanı</h3>

                <div className="bio-content">{renderBiographyContent()}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Mayor;
